import React from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary'
import { isChunkLoadError, reloadForFreshChunks } from './lib/chunkRecovery'
import './index.css'

// Recover from failed dynamic module imports (stale cache after an update):
// reload with a cache-buster instead of showing a blank screen.
// Don't preventDefault on vite:preloadError — the import must still reject.
window.addEventListener('vite:preloadError', () => {
  reloadForFreshChunks()
})
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault()
    reloadForFreshChunks()
  }
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ChunkErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ChunkErrorBoundary>
  </StrictMode>
);
